import React from 'react';
import TcDayPickerSet from '../../../tc-ui/date-picker-set';
import { call, compose, concat, prop, equals, reject, addIndex, or, head, ifElse, and, always, T, cond, identity, path } from 'ramda';
import DateUtils from '../../../../utils/date-utils';

const DateRanges = ({
  dateRanges,
  datesNotEditable,
  contractingPeriod,
  takenDateRanges,
  onChangeDate,
  removeADateRange,
  addADateRange,
}) => {
  if (datesNotEditable) return (<div>
    {(dateRanges || []).map((range, rangeIndex) => {
      return (
        <div key={rangeIndex}>
          {
            DateUtils.displayRange(range)
          }
        </div>);
    })}
    </div>);
  return (
    <div>
      {
        dateRanges.map((range, index) => {
          const currentFromDate = prop('seasonStartDate', range);
          const currentToDate = prop('seasonEndDate', range);
          const ifCurrentExist = ifElse(
            equals('getStart'),
              always(currentFromDate || currentToDate),
            always(currentToDate || currentFromDate),
          );
          const getInitialDate = cond([
            [() => or(currentFromDate, currentToDate), ifCurrentExist],
            [() => and(dateRanges.length > 1, index), always(path([index - 1, 'seasonEndDate'], dateRanges) || path([index - 1, 'seasonStartDate'], dateRanges))],
            [T, always(prop('startDate', contractingPeriod))],
          ]);
          const initialStartDateMonth = getInitialDate('getStart');
          const initialEndDateMonth = getInitialDate('getEnd');
          const newTakenRanges = call(compose(
            concat(takenDateRanges),
            DateUtils.transformDateRanges,
            addIndex(reject)((_, filterIndex) => equals(filterIndex, index))
          ), dateRanges);
          return (
            <TcDayPickerSet
              key={index}
              endDateCloseOnSelect
              startDateCloseOnSelect
              disableDeleteButton={dateRanges.length < 2}
              startDateContainerStyle={{ display: 'inline-block', marginLeft: '3%', width: '32%' }}
              startDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
              endDateContainerStyle={{ display: 'inline-block', marginLeft: '3%', width: '32%' }}
              endDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
              addButtonStyle={{ marginLeft: '16px', lineHeight: '24px', verticalAlign: 'middle' }}
              deleteButtonStyle={{ lineHeight: '24px', verticalAlign: 'middle' }}
              startDateHintText="Start Date"
              endDateHintText="End Date"
              disabledRanges={newTakenRanges}
              initialStartDateMonth={initialStartDateMonth}
              startDateEnableFrom={contractingPeriod.startDate}
              startDateEnableTo={contractingPeriod.endDate}
              initialEndDateMonth={initialEndDateMonth}
              endDateEnableFrom={currentFromDate || contractingPeriod.startDate}
              endDateEnableTo={contractingPeriod.endDate}
              startDate={currentFromDate}
              endDate={currentToDate}
              onChangeStartDate={onChangeDate(index, 'seasonStartDate')}
              onChangeEndDate={onChangeDate(index, 'seasonEndDate')}
              onDelete={() => removeADateRange(index)}
              onAdd={() => addADateRange(index)}
            />
          );
        })
      }
    </div>
  );
};

export default DateRanges;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/seasonal-sections/date-ranges.jsx